/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GastherapyTerminateAliases {
  DATE_HOUR_INPUT = 'date-hour-input',
  FIELD_DATE_TERMINATE = 'field-date-terminate',
  FIELD_TEXT_AREA_OBSERVATION = 'field-text-area-observation',
  FORM_CONTENT = 'form-content',
  FRAGMENT_REFERENCE_TITLE = 'fragment-reference-title',
  PANEL_CONTENT = 'panel-content',
  PANEL_HEADER = 'panel-header',
  PANEL_MEDICATION_MEDICATION = 'panel-medication-medication',
  TERMINATE_GASTHERAPY_LAYOUT = 'terminate-gastherapy-layout',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
}
export { GastherapyTerminateAliases };
